export type HskLevelKey = 1 | 2 | 3 | 4 | 5 | 6 | 79;

export type HskVersionKey = "hsk2" | "hsk3" | "hsk2026";

const HSK_LEVEL_KEY_SET: ReadonlySet<number> = new Set([1, 2, 3, 4, 5, 6, 79]);

export function isHskLevelKey(value: number): value is HskLevelKey {
  return HSK_LEVEL_KEY_SET.has(value);
}

export function parseHskLevelToggleValue(value: string): HskLevelKey | undefined {
  const parsed = value === "79" ? 79 : Number(value);
  return isHskLevelKey(parsed) ? parsed : undefined;
}

export function resolveAvailableHskLevel(
  level: number,
  availableLevels: readonly HskLevelKey[],
): HskLevelKey | undefined {
  if (!isHskLevelKey(level) || !availableLevels.includes(level)) {
    return undefined;
  }
  return level;
}

export function getHskLevelsForVersion(hskVersion: HskVersionKey): readonly HskLevelKey[] {
  if (hskVersion === "hsk2") {
    return [1, 2, 3, 4, 5, 6];
  }
  return [1, 2, 3, 4, 5, 6, 79];
}

export function getHskLevelLabel(level: HskLevelKey): string {
  return level === 79 ? "7-9" : String(level);
}
